import React from 'react';
import {
  LineageBrowserDataCatalogProvider,
  VizPortalDataCatalogProviderProps,
} from '../../../data-catalog-shared';
import { VirtualConnectionLineageSubplaceRouter, VirtualConnectionLineageSubplaceRouterProps } from './VirtualConnectionLineageSubplace';

export type EmbeddableVirtualConnectionSubplaceProps = VizPortalDataCatalogProviderProps & VirtualConnectionLineageSubplaceRouterProps;

export function EmbeddableVirtualConnectionSubplaceWithoutRouter(props: EmbeddableVirtualConnectionSubplaceProps): JSX.Element {
  return (
    <LineageBrowserDataCatalogProvider {...props}>
      <VirtualConnectionLineageSubplaceRouter vizportalUrlId={props.vizportalUrlId} />
    </LineageBrowserDataCatalogProvider>
  );
}
